// =============================================================================
// GENERATED by scripts/build-shared.cjs from functions/src/shared/ppeReport.js
// DO NOT EDIT — edit the canonical file and re-run `node scripts/build-shared.cjs`.
// (TASK-9452: ONE PPE report — HR Reports tab, Claude connector, Ask DispatchDeck.)
//
// Side-effect module: attaches `window.PpeReport`. hr.js (Safety Equipment →
// Manage → Reports) reads it at CALL time.
//
// The body below is the canonical file's PORTABLE CORE, copied byte for byte.
// =============================================================================
(function () {
  'use strict';

  var PPE_REPORT_BASIS = 'dateReceived';
  var PPE_REPORT_BASIS_LABEL = 'date received (the date on each PPE entry, in the company\'s timezone)';
  var PPE_REPORT_PRESETS = ['last_7_days', 'this_month', 'last_month', 'last_week', 'all'];
  var _PPE_MONTHS = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];

  /** Absent / unrecognised status === legacy 'issued' (PersonSections.equipmentStatus). */
  function ppeStatus(rec) {
    var s = String((rec && rec.status) || '').trim();
    return (s === 'returned' || s === 'unreturned' || s === 'damaged-intentional') ? s : 'issued';
  }

  /** TASK-9719 — a voided issue (kept on file, left out of every count). */
  function ppeIsVoided(rec) {
    return !!(rec && rec.voidedAt);
  }

  /**
   * TASK-9719 — how many of a returned row came back. 0 unless the row is
   * returned; then `returnedQty` when it is a whole number in 0..qty, else the
   * whole quantity (rows returned before partial returns existed).
   */
  function ppeReturnedQty(rec, qty) {
    if (ppeStatus(rec) !== 'returned') return 0;
    var raw = rec ? rec.returnedQty : undefined;
    var n = typeof raw === 'number' ? raw : parseInt(raw, 10);
    if (raw === undefined || raw === null || raw === '' || !isFinite(n) || n !== Math.floor(n)) return qty;
    return n < 0 ? 0 : (n > qty ? qty : n);
  }

  /** { qty, flagged } — parseInt || 1, never below 1; a bad value is flagged. */
  function ppeQty(rec) {
    var raw = rec ? rec.quantity : undefined;
    var n = parseInt(raw, 10);
    if (!isFinite(n) || n < 1) {
      var blank = raw === undefined || raw === null || raw === '';
      return { qty: 1, flagged: !blank };
    }
    return { qty: n, flagged: false };
  }

  // Every lookup table here is keyed by text people typed (item, size, name), so
  // it has NO prototype: "constructor" or "__proto__" as an item or a size must be
  // an ordinary key, never Object.prototype (COD Code Reviewer 2026-10-08).
  function _ppeDict() { return Object.create(null); }

  function _ppeTrim(v) { return String(v == null ? '' : v).replace(/\s+/g, ' ').trim(); }
  /** The grouping key for an item type: trimmed, case-insensitive. */
  function ppeTypeKey(v) { return _ppeTrim(v).toLowerCase(); }

  /** A real calendar day written YYYY-MM-DD. */
  function isPpeDayKey(s) {
    if (typeof s !== 'string' || !/^\d{4}-\d{2}-\d{2}$/.test(s)) return false;
    var y = +s.slice(0, 4); var m = +s.slice(5, 7); var d = +s.slice(8, 10);
    var t = new Date(Date.UTC(y, m - 1, d));
    return t.getUTCFullYear() === y && t.getUTCMonth() === m - 1 && t.getUTCDate() === d;
  }

  /** Calendar arithmetic on day keys (UTC math on a pure date — no zone involved). */
  function ppeAddDays(dayKey, n) {
    var t = Date.UTC(+dayKey.slice(0, 4), +dayKey.slice(5, 7) - 1, +dayKey.slice(8, 10)) + n * 86400000;
    return new Date(t).toISOString().slice(0, 10);
  }

  function _ppeDayLabel(k, withYear) {
    var s = _PPE_MONTHS[+k.slice(5, 7) - 1] + ' ' + (+k.slice(8, 10));
    return withYear ? s + ', ' + k.slice(0, 4) : s;
  }

  /** "Sep 22 – 28, 2026" style human label for an inclusive range. */
  function ppeRangeLabel(start, end) {
    if (!start && !end) return 'All dates on file';
    if (start && !end) return 'From ' + _ppeDayLabel(start, true);
    if (!start && end) return 'Through ' + _ppeDayLabel(end, true);
    if (start === end) return _ppeDayLabel(start, true);
    if (start.slice(0, 4) === end.slice(0, 4)) return _ppeDayLabel(start, false) + ' – ' + _ppeDayLabel(end, true);
    return _ppeDayLabel(start, true) + ' – ' + _ppeDayLabel(end, true);
  }

  /**
   * A named preset → { start, end, label } in the company's days. `todayKey` is
   * the company-local today, supplied by the caller (browser local day / server
   * tenant zone). last_7_days = today and the 6 days before it; last_week = the
   * previous full Monday–Sunday week; all = no date limit.
   */
  function ppePresetRange(preset, todayKey) {
    if (PPE_REPORT_PRESETS.indexOf(preset) < 0) return { error: 'Unknown period "' + String(preset) + '". Use one of: ' + PPE_REPORT_PRESETS.join(', ') + '.' };
    if (preset === 'all') return { start: null, end: null, label: ppeRangeLabel(null, null) };
    if (!isPpeDayKey(todayKey)) return { error: 'today is not a valid day.' };
    var start; var end;
    if (preset === 'last_7_days') { start = ppeAddDays(todayKey, -6); end = todayKey; }
    else if (preset === 'this_month') { start = todayKey.slice(0, 8) + '01'; end = todayKey; }
    else if (preset === 'last_month') { end = ppeAddDays(todayKey.slice(0, 8) + '01', -1); start = end.slice(0, 8) + '01'; }
    else {
      var dow = new Date(Date.UTC(+todayKey.slice(0, 4), +todayKey.slice(5, 7) - 1, +todayKey.slice(8, 10))).getUTCDay();
      var sinceMonday = (dow + 6) % 7;
      start = ppeAddDays(todayKey, -sinceMonday - 7); end = ppeAddDays(start, 6);
    }
    return { start: start, end: end, label: ppeRangeLabel(start, end) };
  }

  // Common names people use for PPE → patterns that recognise both the words a
  // person types and the item names a company set up. A query matches a concept
  // when any pattern hits the query; an item type matches the concept when any
  // pattern hits its name.
  var PPE_TYPE_ALIASES = [
    { concept: 'gas monitor', patterns: [/\bh2s\b/, /\bgas\b/, /\b(4|four|quad|multi) ?gas\b/, /\bmonitors?\b/, /\bdetectors?\b/, /\bsniffers?\b/, /\bbump\b/] },
    { concept: 'gloves', patterns: [/\bgloves?\b/] },
    { concept: 'safety glasses', patterns: [/\bglasses\b/, /\beye ?pro(tection)?\b/, /\bsafety specs\b/, /\bgoggles?\b/] },
    { concept: 'hard hat', patterns: [/\bhard ?hats?\b/, /\bhelmets?\b/] },
    { concept: 'face shield', patterns: [/\bface ?shields?\b/] },
    { concept: 'wet gear', patterns: [/\bwet ?gear\b/, /\brain ?(gear|suit|coat|jacket)s?\b/, /\bslickers?\b/] },
    { concept: 'hi-vis vest', patterns: [/\bvests?\b/, /\bhi ?vis\b/, /\bhigh ?vis(ibility)?\b/, /\breflective\b/] },
    { concept: 'hearing protection', patterns: [/\bear ?plugs?\b/, /\bhearing\b/, /\bear ?(pro|muffs?)\b/] },
    { concept: 'boots', patterns: [/\bboots?\b/, /\bsteel ?toes?\b/] },
    { concept: 'respirator', patterns: [/\brespirators?\b/, /\bn95\b/, /\bmasks?\b/] },
    { concept: 'fall protection', patterns: [/\bharness(es)?\b/, /\bfall ?(protection|arrest)\b/, /\blanyards?\b/] },
    { concept: 'fr clothing', patterns: [/\bfrs?\b/, /\bflame ?(resistant|retardant)\b/, /\bfire ?(resistant|retardant)\b/, /\bcoveralls?\b/] },
  ];

  function _ppeNorm(s) { return ppeTypeKey(s).replace(/[^a-z0-9]+/g, ' ').trim(); }

  /**
   * Resolve what a person typed ("H2S", "gas", "4-gas", "monitor") to the item
   * types that exist. Returns { matched: [names], how, concept? }. `how` is
   * exact | contains | alias | words | none. Several matches come back as
   * several — the caller asks rather than picking one.
   */
  function matchPpeType(query, typeNames) {
    var q = _ppeNorm(query);
    var seen = _ppeDict(); var names = [];
    for (var i = 0; i < (typeNames || []).length; i++) {
      var nm = _ppeTrim(typeNames[i]);
      var k = ppeTypeKey(nm);
      if (!nm || seen[k]) continue;
      seen[k] = true; names.push(nm);
    }
    names.sort(function (a, b) { return a.toLowerCase() < b.toLowerCase() ? -1 : (a.toLowerCase() > b.toLowerCase() ? 1 : 0); });
    if (!q) return { matched: [], how: 'none' };
    var exact = names.filter(function (n) { return _ppeNorm(n) === q; });
    if (exact.length) return { matched: exact, how: 'exact' };
    if (q.length >= 3) {
      var contains = names.filter(function (n) { var nn = _ppeNorm(n); return nn.indexOf(q) >= 0 || q.indexOf(nn) >= 0; });
      if (contains.length) return { matched: contains, how: 'contains' };
    }
    for (var a = 0; a < PPE_TYPE_ALIASES.length; a++) {
      var al = PPE_TYPE_ALIASES[a];
      var hitQ = al.patterns.some(function (p) { return p.test(q); });
      if (!hitQ) continue;
      var byAlias = names.filter(function (n) { var nn = _ppeNorm(n); return al.patterns.some(function (p) { return p.test(nn); }); });
      if (byAlias.length) return { matched: byAlias, how: 'alias', concept: al.concept };
    }
    var words = q.split(' ').filter(function (w) { return w.length >= 3; });
    var byWords = names.filter(function (n) { var nw = _ppeNorm(n).split(' '); return words.some(function (w) { return nw.indexOf(w) >= 0; }); });
    if (byWords.length) return { matched: byWords, how: 'words' };
    return { matched: [], how: 'none' };
  }

  /** Who a row belongs to: personId, else the typed name, else unknown. */
  function ppePersonKey(rec) {
    var pid = _ppeTrim(rec && rec.personId);
    if (pid) return 'id:' + pid;
    var nm = ppeTypeKey(rec && rec.personName);
    return nm ? 'name:' + nm : 'unknown';
  }

  function _ppeCmp(a, b) { return a < b ? -1 : (a > b ? 1 : 0); }
  function _ppeBestLabel(counts) {
    var best = null;
    for (var label in counts) {
      if (!Object.prototype.hasOwnProperty.call(counts, label)) continue;
      if (best === null || counts[label] > counts[best] || (counts[label] === counts[best] && label < best)) best = label;
    }
    return best;
  }

  /**
   * The report. `records` = raw safetyEquipment docs ({ id, ...data }).
   * opts.start / opts.end = inclusive YYYY-MM-DD (either may be omitted);
   * opts.personKey (from ppePersonKey) or opts.personId narrows to one person;
   * opts.types = item type names (any case) to keep. Returns { error } on a bad
   * range. Rows without a usable dateReceived are kept only when no date limit
   * is set, and counted in totals.undatedRows either way.
   */
  function buildPpeReport(records, opts) {
    var o = opts || {};
    var start = o.start == null || o.start === '' ? null : o.start;
    var end = o.end == null || o.end === '' ? null : o.end;
    if (start !== null && !isPpeDayKey(start)) return { error: 'start must be a real date written YYYY-MM-DD.' };
    if (end !== null && !isPpeDayKey(end)) return { error: 'end must be a real date written YYYY-MM-DD.' };
    if (start !== null && end !== null && start > end) return { error: 'start is after end.' };
    var bounded = start !== null || end !== null;
    var personKey = o.personKey ? String(o.personKey) : (o.personId ? 'id:' + _ppeTrim(o.personId) : null);
    var typeKeys = null;
    if (Array.isArray(o.types) && o.types.length) {
      typeKeys = _ppeDict();
      for (var t = 0; t < o.types.length; t++) typeKeys[ppeTypeKey(o.types[t])] = true;
    }

    var lines = []; var undatedRows = 0; var undatedExcluded = 0; var voidedRows = 0;
    var list = Array.isArray(records) ? records : [];
    for (var i = 0; i < list.length; i++) {
      var r = list[i];
      if (!r || typeof r !== 'object') continue;
      var date = isPpeDayKey(r.dateReceived) ? r.dateReceived : null;
      var tKey = ppeTypeKey(r.equipmentType);
      var pKey = ppePersonKey(r);
      if (personKey && pKey !== personKey) continue;
      if (typeKeys && !typeKeys[tKey]) continue;
      if (bounded && date && ((start !== null && date < start) || (end !== null && date > end))) continue;
      // TASK-9719 — a voided issue never happened for counting purposes.
      if (ppeIsVoided(r)) { voidedRows++; continue; }
      if (!date) undatedRows++;
      if (bounded && !date) { undatedExcluded++; continue; }
      var q = ppeQty(r);
      var status = ppeStatus(r);
      var flags = [];
      if (q.flagged) flags.push('quantity_not_a_positive_number');
      if (!tKey) flags.push('no_item_type');
      lines.push({
        id: r.id == null ? null : String(r.id),
        date: date,
        personKey: pKey,
        personId: _ppeTrim(r.personId) || null,
        personName: _ppeTrim(r.personName) || null,
        type: _ppeTrim(r.equipmentType) || 'Unspecified item',
        typeKey: tKey || '(none)',
        size: _ppeTrim(r.size) || null,
        quantity: q.qty,
        serialNumber: _ppeTrim(r.serialNumber) || null,
        source: r.source === 'driver' ? 'driver' : 'admin',
        status: status,
        returned: status === 'returned',
        returnedQty: ppeReturnedQty(r, q.qty),
        signedOff: !!r.acknowledgment || r.acknowledged === true,
        flags: flags,
      });
    }
    lines.sort(function (a, b) {
      return _ppeCmp(b.date || '', a.date || '') || _ppeCmp((a.personName || '').toLowerCase(), (b.personName || '').toLowerCase())
        || _ppeCmp(a.typeKey, b.typeKey) || _ppeCmp(a.id || '', b.id || '');
    });

    var items = _ppeDict(); var people = _ppeDict();
    var totals = { issued: 0, returned: 0, outstanding: 0, rows: lines.length, people: 0, itemTypes: 0, flaggedRows: 0, undatedRows: undatedRows, voidedRows: voidedRows };
    for (var j = 0; j < lines.length; j++) {
      var l = lines[j];
      var ret = l.returnedQty;
      totals.issued += l.quantity; totals.returned += ret;
      if (l.flags.length) totals.flaggedRows++;
      var it = items[l.typeKey] || (items[l.typeKey] = { key: l.typeKey, _labels: _ppeDict(), issued: 0, returned: 0, outstanding: 0, rows: 0, _people: _ppeDict(), _sizes: _ppeDict() });
      it._labels[l.type] = (it._labels[l.type] || 0) + 1;
      it.issued += l.quantity; it.returned += ret; it.rows++; it._people[l.personKey] = true;
      var sKey = (l.size || '').toLowerCase();
      var sz = it._sizes[sKey] || (it._sizes[sKey] = { size: l.size, _labels: _ppeDict(), issued: 0, returned: 0, outstanding: 0 });
      if (l.size) sz._labels[l.size] = (sz._labels[l.size] || 0) + 1;
      sz.issued += l.quantity; sz.returned += ret;
      var pe = people[l.personKey] || (people[l.personKey] = { personKey: l.personKey, personId: l.personId, _names: _ppeDict(), issued: 0, returned: 0, outstanding: 0, rows: 0, _items: _ppeDict() });
      if (l.personName) pe._names[l.personName] = (pe._names[l.personName] || 0) + 1;
      pe.issued += l.quantity; pe.returned += ret; pe.rows++;
      var piKey = JSON.stringify([l.typeKey, sKey]); // a tuple key: typed text may contain any delimiter
      var pi = pe._items[piKey] || (pe._items[piKey] = { typeKey: l.typeKey, type: l.type, size: l.size, issued: 0, returned: 0, outstanding: 0 });
      pi.issued += l.quantity; pi.returned += ret;
    }
    totals.outstanding = totals.issued - totals.returned;

    var byItem = [];
    for (var ik in items) {
      if (!Object.prototype.hasOwnProperty.call(items, ik)) continue;
      var g = items[ik];
      var sizes = [];
      for (var sk in g._sizes) {
        if (!Object.prototype.hasOwnProperty.call(g._sizes, sk)) continue;
        var s0 = g._sizes[sk];
        sizes.push({ size: _ppeBestLabel(s0._labels), issued: s0.issued, returned: s0.returned, outstanding: s0.issued - s0.returned });
      }
      sizes.sort(function (a, b) { return (b.issued - a.issued) || _ppeCmp((a.size || '~').toLowerCase(), (b.size || '~').toLowerCase()); });
      byItem.push({ key: g.key, type: _ppeBestLabel(g._labels), issued: g.issued, returned: g.returned, outstanding: g.issued - g.returned, rows: g.rows, people: Object.keys(g._people).length, sizes: sizes });
    }
    byItem.sort(function (a, b) { return (b.issued - a.issued) || _ppeCmp(a.key, b.key); });

    var byEmployee = [];
    for (var pk in people) {
      if (!Object.prototype.hasOwnProperty.call(people, pk)) continue;
      var p = people[pk];
      var its = [];
      for (var k2 in p._items) {
        if (!Object.prototype.hasOwnProperty.call(p._items, k2)) continue;
        var x = p._items[k2]; x.outstanding = x.issued - x.returned; its.push(x);
      }
      its.sort(function (a, b) { return _ppeCmp(a.typeKey, b.typeKey) || _ppeCmp((a.size || '').toLowerCase(), (b.size || '').toLowerCase()); });
      byEmployee.push({ personKey: p.personKey, personId: p.personId, personName: _ppeBestLabel(p._names) || 'Unknown', issued: p.issued, returned: p.returned, outstanding: p.issued - p.returned, rows: p.rows, items: its });
    }
    byEmployee.sort(function (a, b) { return _ppeCmp(a.personName.toLowerCase(), b.personName.toLowerCase()) || _ppeCmp(a.personKey, b.personKey); });
    totals.people = byEmployee.length;
    totals.itemTypes = byItem.length;

    var notes = [
      'Issued counts every item given out in the range, including items later returned. Returned is shown separately; outstanding = issued minus returned.',
      'Includes items drivers logged for themselves. Voided entries are not counted.',
      'This is a record of PPE issued. It is not a basis for charging an employee or deducting pay.',
    ];
    if (bounded && undatedExcluded) notes.push(undatedExcluded + ' entr' + (undatedExcluded === 1 ? 'y has' : 'ies have') + ' no date received and ' + (undatedExcluded === 1 ? 'is' : 'are') + ' not in this date range.');
    if (voidedRows) notes.push(voidedRows + ' voided entr' + (voidedRows === 1 ? 'y is' : 'ies are') + ' left out.');
    if (totals.flaggedRows) notes.push(totals.flaggedRows + ' entr' + (totals.flaggedRows === 1 ? 'y has' : 'ies have') + ' a quantity that is not a positive number; each is counted as 1.');

    return {
      range: { start: start, end: end, basis: PPE_REPORT_BASIS, basisLabel: PPE_REPORT_BASIS_LABEL, label: ppeRangeLabel(start, end) },
      filters: { personKey: personKey, types: typeKeys ? Object.keys(typeKeys).sort() : null },
      totals: totals,
      byItem: byItem,
      byEmployee: byEmployee,
      lines: lines,
      notes: notes,
    };
  }

  /**
   * TASK-9719 — per-item issued / returned / outstanding totals, keyed by the
   * item's grouping key (ppeTypeKey). The SAME numbers as buildPpeReport's
   * byItem (it is built from it), so a later stock view (S2's mismatch strip)
   * can set "taken" beside the ledger without a second way of counting.
   * Same options as buildPpeReport; returns { error } on a bad range.
   */
  function ppeItemTotals(records, opts) {
    var rep = buildPpeReport(records, opts);
    if (rep.error) return { error: rep.error };
    var out = _ppeDict();
    for (var i = 0; i < rep.byItem.length; i++) {
      var it = rep.byItem[i];
      out[it.key] = { type: it.type, issued: it.issued, returned: it.returned, outstanding: it.outstanding, rows: it.rows };
    }
    return out;
  }

  // -----------------------------------------------------------------------------
  // TASK-9722 (S2) — reading the stock LEDGER back. The `supply_*` rows in
  // assetTransactions (written only by functions/src/services/supplyLedger.js)
  // are the record; these helpers turn one item's rows into the mismatch strip
  // ("Taken 120 · Received 100 · On hand −20"), the alert flags, and the History
  // list. ONE copy: the HR Inventory tab, the Roster item, the daily alert
  // digest and (S5) the connector all call these.
  // -----------------------------------------------------------------------------
  var SUPPLY_ROW_LABELS = {
    supply_open: 'Opening count',
    supply_receive: 'Received',
    supply_issue: 'Signed out',
    supply_return: 'Returned',
    supply_void: 'Voided sign-out',
    supply_count: 'Shelf count',
    supply_adjust: 'Adjusted',
    supply_close: 'Stopped counting',
    supply_use: 'Used on a job', // TASK-9730 — sent on a job / used on a field ticket (signed)
  };

  /** Millis from a Firestore Timestamp, {seconds}/{_seconds}, Date, or number; else null. */
  function supplyRowMs(v) {
    if (v == null) return null;
    if (typeof v === 'number') return isFinite(v) ? v : null;
    if (typeof v.toMillis === 'function') return v.toMillis();
    if (typeof v.getTime === 'function') return v.getTime();
    var s = v.seconds != null ? v.seconds : v._seconds;
    if (typeof s === 'number') return s * 1000 + Math.floor(((v.nanoseconds != null ? v.nanoseconds : v._nanoseconds) || 0) / 1e6);
    return null;
  }

  /** Plain-words label for a ledger row type (a non-supply row keeps its own type word). */
  function supplyRowLabel(row) {
    var t = String((row && row.type) || '');
    if (SUPPLY_ROW_LABELS[t]) return SUPPLY_ROW_LABELS[t];
    if (t === 'receipt') return 'Received';
    if (t === 'adjustment') return 'Adjusted';
    if (t === 'dispatch') return 'Sent on a job';
    if (t === 'ticket') return 'Used on a ticket';
    return t ? t.charAt(0).toUpperCase() + t.slice(1) : 'Change';
  }

  /** The signed change a row made (supply rows carry qtyDelta; older rows `quantity`). */
  function supplyRowDelta(row) {
    if (!row) return 0;
    // TASK-9263 — `dispatch` rows were written +qty until 9263; their before/after never lied.
    var d = row.qtyDelta != null ? row.qtyDelta : row.type === 'dispatch' && row.newQty != null && row.previousQty != null ? row.newQty - row.previousQty : row.quantity;
    var n = Number(d);
    return isFinite(n) ? n : 0;
  }

  /** Newest first; ties broken by id so a page boundary is stable. Returns a NEW array. */
  function supplySortRows(rows) {
    return (rows || []).slice().sort(function (a, b) {
      var am = supplyRowMs(a && a.createdAt); var bm = supplyRowMs(b && b.createdAt);
      am = am == null ? -Infinity : am; bm = bm == null ? -Infinity : bm;
      if (am !== bm) return bm - am;
      var ai = String((a && a.id) || ''); var bi = String((b && b.id) || '');
      return ai < bi ? 1 : (ai > bi ? -1 : 0);
    });
  }

  /**
   * One page of an item's History from rows already sorted newest-first.
   * { rows, hasMore, nextOffset }. Size is clamped to 1..100.
   */
  function supplyHistoryPage(sortedRows, offset, size) {
    var list = sortedRows || [];
    var n = Math.max(1, Math.min(100, Math.floor(Number(size) || 25)));
    var from = Math.max(0, Math.floor(Number(offset) || 0));
    var page = list.slice(from, from + n);
    return { rows: page, hasMore: from + n < list.length, nextOffset: from + page.length };
  }

  /**
   * The mismatch strip for ONE tracking period of one item (rows with that
   * openId; other rows are ignored). When openId is not given, the newest
   * opening's openId is used.
   *   opening   — the count typed in when tracking started
   *   received  — stock in
   *   taken     — signed out, NOT counting voided sign-outs, plus net used on
   *               jobs / field tickets (supply_use, TASK-9730)
   *   returned  — good returns put back, not counting voided ones
   *   counted   — net change made by shelf counts (Count now)
   *   adjusted  — net change made by Adjust
   *   onHand    — opening + received − taken + returned + counted + adjusted
   *   voided    — how many sign-outs were voided (they net to zero)
   *   lastCount — { at, expected, counted, delta } for the newest shelf count
   */
  function supplyLedgerTotals(rows, openId) {
    var list = rows || [];
    var oid = openId;
    if (!oid) {
      var bestMs = -Infinity;
      for (var i = 0; i < list.length; i++) {
        var r0 = list[i];
        if (!r0 || r0.type !== 'supply_open' || !r0.openId) continue;
        var m0 = supplyRowMs(r0.createdAt);
        m0 = m0 == null ? 0 : m0;
        if (m0 >= bestMs) { bestMs = m0; oid = r0.openId; }
      }
    }
    var out = { openId: oid || null, opening: 0, received: 0, taken: 0, returned: 0, counted: 0, adjusted: 0, voided: 0, onHand: 0, rows: 0, lastCount: null };
    if (!oid) return out;
    var issued = _ppeDict(); var back = _ppeDict(); var voided = _ppeDict();
    var lastCountMs = -Infinity;
    for (var j = 0; j < list.length; j++) {
      var r = list[j];
      if (!r || r.openId !== oid || String(r.type || '').indexOf('supply_') !== 0) continue;
      var d = supplyRowDelta(r);
      var src = String(r.sourceId || '');
      out.rows++;
      if (r.type === 'supply_open') {
        var c = Number(r.countedQty);
        out.opening = isFinite(c) ? c : (Number(r.balanceAfter) || 0);
      } else if (r.type === 'supply_receive') {
        out.received += d;
      } else if (r.type === 'supply_issue') {
        issued[src] = (issued[src] || 0) - d;
      } else if (r.type === 'supply_return') {
        back[src] = (back[src] || 0) + d;
      } else if (r.type === 'supply_void') {
        voided[src] = true;
      } else if (r.type === 'supply_count') {
        out.counted += d;
        var cm = supplyRowMs(r.createdAt);
        cm = cm == null ? 0 : cm;
        if (cm >= lastCountMs) {
          lastCountMs = cm;
          out.lastCount = { at: cm || null, expected: Number(r.expectedQty) || 0, counted: Number(r.countedQty) || 0, delta: d };
        }
      } else if (r.type === 'supply_adjust') {
        out.adjusted += d;
      } else if (r.type === 'supply_use') {
        out.taken -= d; // TASK-9730 — a job / ticket draw (−) or its reversal (+)
      }
    }
    var k;
    for (k in issued) { if (voided[k]) out.voided++; else out.taken += issued[k]; }
    for (k in back) { if (!voided[k]) out.returned += back[k]; }
    out.onHand = out.opening + out.received - out.taken + out.returned + out.counted + out.adjusted;
    return out;
  }

  /**
   * Alert flags for one stock-tracked item. PURE.
   *   item = { quantity, parLevel? }
   *   opts = { countRows?: ledger rows, sinceMs?: only counts at/after this instant }
   * negative     — the count is below zero
   * belowPar     — a par level (whole number ≥ 1) is set and the count is under
   *                it but not negative (negative already says more)
   * countVariance — a shelf count since `sinceMs` did not match what the system
   *                expected: { net, counts } (net = sum of their changes)
   * Returns { kinds: [...], negative, belowPar, countVariance }.
   */
  function supplyAlertFlags(item, opts) {
    var o = opts || {};
    var q = Number(item && item.quantity);
    q = isFinite(q) ? q : 0;
    var parRaw = item ? item.parLevel : undefined;
    var par = typeof parRaw === 'number' ? parRaw : (typeof parRaw === 'string' && /^\d+$/.test(parRaw.trim()) ? parseInt(parRaw, 10) : NaN);
    var negative = q < 0;
    var belowPar = !negative && isFinite(par) && par === Math.floor(par) && par >= 1 && q < par;
    var since = typeof o.sinceMs === 'number' ? o.sinceMs : -Infinity;
    var net = 0; var counts = 0;
    var cr = o.countRows || [];
    for (var i = 0; i < cr.length; i++) {
      var r = cr[i];
      if (!r || r.type !== 'supply_count') continue;
      var ms = supplyRowMs(r.createdAt);
      if (ms == null || ms < since) continue;
      var d = supplyRowDelta(r);
      if (d === 0) continue;
      net += d; counts++;
    }
    var countVariance = counts ? { net: net, counts: counts } : null;
    var kinds = [];
    if (negative) kinds.push('negative');
    if (belowPar) kinds.push('below_par');
    if (countVariance) kinds.push('count_variance');
    return { kinds: kinds, negative: negative, belowPar: belowPar, countVariance: countVariance };
  }

  // =============================================================================
  // TASK-9728 (S6) — SERIALIZED PPE: gas monitors and other gear tracked one by
  // one as individual Roster assets (trackingMode 'individual', category
  // 'safety_gear'). Issue Equipment picks the serial and stamps
  // safetyEquipment.assetId; who has the unit now and its history are READ from
  // the issue rows that name it. No count moves: a serialized issue is custody,
  // not a take from stock. Never blocks — a unit already out can still be issued
  // (the picker says who has it); the history then shows both.
  // =============================================================================

  /** The asset's serial / ID for display ('' when it has none). */
  function ppeSerialLabel(asset) {
    return _ppeTrim(asset && (asset.serialNumber || asset.unit || asset.nickname || ''));
  }

  /**
   * PURE. The individual Safety Gear assets that can be picked for one PPE item
   * type: same name (ppeTypeKey) or the asset the type is linked to
   * (linkedAssetId, set by the Roster → PPE link). Inactive assets and quantity
   * items are left out. Sorted by serial, then name, then id.
   *   assets — Roster asset docs ({ id, name, category, trackingMode, active, serialNumber })
   *   type   — the safetyEquipmentTypes doc ({ name, linkedAssetId? }) or null
   */
  function ppeSerialAssetsForType(assets, type) {
    var key = ppeTypeKey(type && type.name);
    var linked = type && typeof type.linkedAssetId === 'string' ? type.linkedAssetId : '';
    var out = [];
    var list = assets || [];
    for (var i = 0; i < list.length; i++) {
      var a = list[i];
      if (!a || !a.id || a.active === false) continue;
      if (a.trackingMode !== 'individual' || a.category !== 'safety_gear') continue;
      if ((linked && a.id === linked) || (key && ppeTypeKey(a.name) === key)) out.push(a);
    }
    return out.sort(function (x, y) {
      var c = _ppeCmp(ppeSerialLabel(x).toLowerCase(), ppeSerialLabel(y).toLowerCase());
      if (c) return c;
      c = _ppeCmp(ppeTypeKey(x.name), ppeTypeKey(y.name));
      return c || _ppeCmp(String(x.id), String(y.id));
    });
  }

  /**
   * PURE. Who has ONE serialized asset now, and its history, from the
   * safetyEquipment rows that name it (row.assetId === assetId).
   *   records — issue rows ({ id, assetId, personId, personName, dateReceived,
   *             status, returnCondition, voidedAt, voidReason, createdAt })
   * Returns {
   *   state:   'out' (someone holds it) | 'in' (back / never issued) |
   *            'not_returned' (the last holder never gave it back),
   *   holders: open rows, newest first (more than one = issued twice; never refused),
   *   last:    the newest non-voided row or null,
   *   lastReturnDamaged: the newest row came back damaged,
   *   history: every row, newest first, voided included (marked voided)
   * }
   * Status reads ppeStatus (absent ⇒ 'issued'). A voided row is history only.
   * A driver self-log (source 'driver') is IGNORED: only the office's Issue
   * Equipment links a unit, and a PIN session may write any field on its own
   * self-log (no key allowlist), so its assetId cannot be trusted (COD 2026-10-15).
   * `everIssued` = at least one office row that is not voided names this unit.
   */
  function ppeSerialCustody(records, assetId) {
    var rows = [];
    var list = records || [];
    for (var i = 0; i < list.length; i++) {
      var r = list[i];
      if (!r || !assetId || r.assetId !== assetId || r.source === 'driver') continue;
      var voided = ppeIsVoided(r);
      var st = ppeStatus(r);
      rows.push({
        recordId: String(r.id || r.recordId || ''),
        personId: String(r.personId || ''),
        personName: _ppeTrim(r.personName),
        dateReceived: isPpeDayKey(r.dateReceived) ? r.dateReceived : '',
        status: voided ? 'voided' : st,
        returnCondition: st === 'returned' ? (r.returnCondition === 'damaged' ? 'damaged' : 'good') : '',
        returnedMs: supplyRowMs(r.returnedAt),
        createdMs: supplyRowMs(r.createdAt),
        voidReason: voided ? _ppeTrim(r.voidReason) : '',
        serialNumber: _ppeTrim(r.serialNumber),
      });
    }
    rows.sort(function (a, b) {
      if (a.dateReceived !== b.dateReceived) return a.dateReceived < b.dateReceived ? 1 : -1;
      var am = a.createdMs == null ? -Infinity : a.createdMs; var bm = b.createdMs == null ? -Infinity : b.createdMs;
      if (am !== bm) return bm - am;
      return a.recordId < b.recordId ? 1 : (a.recordId > b.recordId ? -1 : 0);
    });
    var holders = []; var last = null;
    for (var j = 0; j < rows.length; j++) {
      if (rows[j].status === 'voided') continue;
      if (!last) last = rows[j];
      if (rows[j].status === 'issued') holders.push(rows[j]);
    }
    var state = 'in';
    if (holders.length) state = 'out';
    else if (last && (last.status === 'unreturned' || last.status === 'damaged-intentional')) state = 'not_returned';
    return {
      state: state,
      holders: holders,
      last: last,
      lastReturnDamaged: !!(last && last.status === 'returned' && last.returnCondition === 'damaged'),
      everIssued: !!last,
      history: rows,
    };
  }

  /**
   * TASK-9723 — how many to order to get a stock-tracked item back up. PURE.
   *   item = { quantity, parLevel?, parTarget? }
   * 0 unless a par level (whole number ≥ 1, read the same way supplyAlertFlags
   * reads it) is set and the count is under it. Then the gap to the fill-to
   * amount (parTarget, when it is a whole number ≥ the par) or to the par itself.
   * One rule for the Roster badge, the daily inventory email and the connector.
   */
  function supplyReorderQty(item) {
    var whole = function (v) {
      var n = typeof v === 'number' ? v : (typeof v === 'string' && /^\d+$/.test(v.trim()) ? parseInt(v, 10) : NaN);
      return isFinite(n) && n === Math.floor(n) ? n : NaN;
    };
    var q = Number(item && item.quantity);
    q = isFinite(q) ? q : 0;
    var par = whole(item ? item.parLevel : undefined);
    if (!(par >= 1) || q >= par) return 0;
    var tgt = whole(item ? item.parTarget : undefined);
    var fillTo = tgt >= par ? tgt : par;
    return Math.max(0, fillTo - q);
  }

  window.PpeReport = Object.freeze({
    BASIS: PPE_REPORT_BASIS,
    BASIS_LABEL: PPE_REPORT_BASIS_LABEL,
    PRESETS: PPE_REPORT_PRESETS.slice(),
    status: ppeStatus,
    isVoided: ppeIsVoided,
    returnedQty: ppeReturnedQty,
    qty: ppeQty,
    typeKey: ppeTypeKey,
    isDayKey: isPpeDayKey,
    addDays: ppeAddDays,
    rangeLabel: ppeRangeLabel,
    presetRange: ppePresetRange,
    matchType: matchPpeType,
    personKey: ppePersonKey,
    build: buildPpeReport,
    itemTotals: ppeItemTotals,
    // TASK-9722 (S2) — the stock ledger read back (mismatch strip, alerts, History)
    SUPPLY_ROW_LABELS: Object.freeze(Object.assign({}, SUPPLY_ROW_LABELS)),
    rowMs: supplyRowMs,
    rowLabel: supplyRowLabel,
    rowDelta: supplyRowDelta,
    sortRows: supplySortRows,
    historyPage: supplyHistoryPage,
    ledgerTotals: supplyLedgerTotals,
    alertFlags: supplyAlertFlags,
    // TASK-9728 (S6) — serialized PPE: pickable serials + who has a unit now
    serialLabel: ppeSerialLabel,
    serialAssetsForType: ppeSerialAssetsForType,
    serialCustody: ppeSerialCustody,
    // TASK-9723 (S3) — how many to order back up to par / fill-to
    reorderQty: supplyReorderQty
  });
})();
